<template>
  <div id="hotWaterSmart">
    <div class="selecteMonth">
      <label>选择月份:</label>
      <el-date-picker
        class="selectedDateWidget"
        v-model="selectedMonth"
        type="month"
        placeholder="请选择月份"
      ></el-date-picker>
      <el-button class="okBtn" type="primary" @click="changeMonthAction()"
        >确认</el-button
      >
    </div>
    <div class="systemBox" v-for="(item, index) in dataSource" :key="index">
      <div>
        <h3>{{ item.chartTitle }}</h3>
      </div>
      <div class="chartBoxCls">
        <div class="chart">
          <div
            class="chartItem"
            v-for="(chartDataItem, chartItemIndex) in item.chartData"
            :key="chartItemIndex"
          >
            <smartEnergyChart :dataSource="chartDataItem"></smartEnergyChart>
          </div>
        </div>
        <div class="statisticalData">
          <ul class="statisticalUl">
            <li
              class="statisticalItem"
              v-for="(
                statisticalItem, statisticalIndex
              ) in item.statisticalData"
              :key="statisticalIndex"
            >
              <label>{{ statisticalItem.dataName + ":" }}</label>
              <label>{{ statisticalItem.value }}</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { energyDataType, energySystemType } from "@/utils/typeParam";
import smartEnergyChart from "@/components/subComponents/smartEnergyChartComponent";
import requestObjc from "@/utils/requestObjc";
import mainStore from "@/store/storeMain";
import { mapGetters } from "vuex";

export default {
  name: "hotWaterSmart",
  store: mainStore,
  components: {
    smartEnergyChart,
  },
  data() {
    return {
      selectedMonth: Date,
      selectedMonthStr: "",
      oldSelectedMonthStr: "",
      dataSource: [],
    };
  },
  props: {},
  computed: {
    ...mapGetters({
      curHouseInfo: "getCurHouseInfo",
    }),
  },
  methods: {
    //请求数据
    requestData() {
      var gateway = this.curHouseInfo.gatewayId;
      var params = {
        systemCode: energySystemType.hotWaterElectricity,
        date: this.selectedMonthStr,
      };
      requestObjc
        .requestSmartSystemEnergys(params, gateway)
        .then((res) => {
          var resData = JSON.parse(JSON.stringify(res.data.dataList));
          resData.forEach((objc, index) => {
            var smartEnergyModel = Object();
            smartEnergyModel.systemType = objc.systemType;
            smartEnergyModel.statisticalData = objc.statisticalData;
            switch (objc.systemType) {
              case energySystemType.hotWaterElectricity:
                smartEnergyModel.chartTitle = "热水系统能耗对比";
                break;
              case energySystemType.airElectricity:
                smartEnergyModel.chartTitle = "采暖系统能耗对比";
                break;
            }
            var chartDataArr = [];
            var chartData0 = Object();
            var chartData1 = Object();
            var xAxisData = [];
            var yAxisData0 = [];
            var yAxisData1 = [];
            objc.chartData[0].data.forEach((item, index) => {
              xAxisData.push(item.key);
            });
            objc.chartData.forEach((chartDataItem, index) => {
              var yAxisDataItem = Object();
              var dataArr = [];
              yAxisDataItem.energyType = chartDataItem.type;
              yAxisDataItem.yAxisIndex = 0;
              if (yAxisDataItem.energyType == energyDataType.gas) {
                yAxisDataItem.yAxisIndex = 1;
              }
              chartDataItem.data.forEach((dataItem, index) => {
                dataArr.push(dataItem.value);
              });
              yAxisDataItem.dataArr = dataArr;
              if (
                yAxisDataItem.energyType ==
                energyDataType.heaterConsumptionGasRate
              ) {
                yAxisData1.push(yAxisDataItem);
              } else {
                yAxisData0.push(yAxisDataItem);
              }
            });
            chartData0.xAxisData = xAxisData;
            chartData0.yAxisData = yAxisData0;
            chartData1.xAxisData = xAxisData;
            chartData1.yAxisData = yAxisData1;
            chartDataArr.push(chartData0);
            chartDataArr.push(chartData1);
            smartEnergyModel.chartData = chartDataArr;
            this.dataSource.push(smartEnergyModel);
          });
        })
        .catch((error) => {
          console.log("获取智能能耗失败:" + error);
        });
    },
    //切换月份
    changeMonthAction() {
      if (this.oldSelectedMonthStr == this.selectedMonthStr) {
        return;
      }
      this.oldSelectedMonthStr = this.selectedMonthStr;
      var selMonthStr = this.conversionSelMonth();
      this.$set(this, "selectedMonthStr", selMonthStr);
      this.$set(this, "dataSource", []);
      this.requestData();
    },
    //转换时间
    conversionSelMonth() {
      var year = this.selectedMonth.getFullYear();
      var month = this.selectedMonth.getMonth() + 1 + "";
      if (month.length == 1) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
  },
  mounted() {
    var nowDate = new Date();
    var nowYear = nowDate.getFullYear();
    var nowMonth = nowDate.getMonth() + 1 + "";
    if (nowMonth.length == 1) {
      nowMonth = "0" + nowMonth;
    }
    this.$set(this, "selectedMonth", nowDate);
    this.$set(this, "selectedMonthStr", nowYear + "-" + nowMonth);
    this.requestData();
  },
};
</script>

<style scoped>
#hotWaterSmart {
  width: 85%;
  margin: 0 auto;
  margin-top: 30px;
  text-align: start;
}
.selecteMonth {
  width: 100%;
}
.selectedDateWidget,
.okBtn {
  margin-left: 20px;
}
.systemBox {
  width: 100%;
  background-color: white;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
  border-radius: 10px;
  text-align: center;
  padding: 20px 0px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.chartBoxCls {
  width: 90%;
  height: 800px;
  padding: 40px;
  margin: 0 auto;
  text-align: start;
  display: flex;
  justify-content: space-between;
}
.chart {
  display: inline-block;
  width: 75%;
  height: 100%;
}
.chartItem {
  width: 100%;
  height: 400px;
  margin-bottom: 30px;
}
.statisticalData {
  display: inline-block;
  width: 20%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.statisticalUl {
  width: 100%;
  list-style: none;
}
.statisticalItem {
  margin: 20px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartSystems/hotWaterSmart.vue